import { Component, Input, OnInit } from "@angular/core";
import { FilterService } from "@progress/kendo-angular-grid";
import { CustomFilterCell } from '../../classes/custom-filter-cell';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
    selector: 'chassis-datatable-filter-menu-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
})
export class SelectComponent extends CustomFilterCell implements OnInit {
    /**
     * The select options list.
     */
    @Input() public source: Array<{ value: string, text: string }> = [];

    public data: Array<{ value: string, text: string }>;

    constructor(filterService: FilterService) {
        super(filterService);
    }

    public ngOnInit(): void {
        // Get the select options from the column options.
        this.source = this.options.data;

        this.data = this.source;
    }

    /**
     * Search changed
     *
     * @param filter
     * @return void
     */
    public filterChange(filter: string): void {
        this.data = this.source.filter((s) => s.value.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }

    /**
     * Value changed
     *
     * @param value
     * @return void
     */
    public valueChange(value: any): void {
        this.filter = this.removeFilter(this.column.field);

        const filters = [];

        filters.push({
            field: this.column.field,
            operator: 'eq',
            value: value
        });

        const root: CompositeFilterDescriptor = this.filter || {
            logic: 'and',
            filters: []
        };

        if (filters.length) {
            root.filters.push(...filters);
        }

        this.filterService.filter(root);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/menu/select/select.component.ts